import type { GetUsersParams } from '@vlabs/api/artemy/model/';

import { createGenericFiltersContext } from '@vlabs/monokit/shared/lib';

const [
  useUserListFilters,
  UserListFiltersProvider,
] = createGenericFiltersContext<GetUsersParams>({
  displayName: 'UserListPageFilters',
});

export {
  useUserListFilters,
  UserListFiltersProvider,
};
